'use client'

import { useParams } from 'next/navigation'
import { useTexts } from '@/contexts/LanguageContext'
import DocumentRow from '../../resources/components/DocumentRow'
import { useDocuments } from '../../resources/useDocuments'
import { TRUST_CENTER_SECTIONS, trustCenterPath } from '../../utils'
import SectionHeader from './SectionHeader'

const MAX_DOCUMENTS_TO_SHOW = 6

export default function DocumentsOverview() {
  const { DOCUMENTS } = useTexts().PUBLIC_TRUST_CENTER.OVERVIEW
  const { orgToken } = useParams<{ orgToken: string }>()
  const { documents, privateNames } = useDocuments()
  if (documents.length === 0) return null
  return (
    <section className="flex flex-col gap-3.5">
      <SectionHeader
        title={DOCUMENTS.TITLE}
        subtitle={DOCUMENTS.SUBTITLE}
        link={{ href: trustCenterPath(orgToken, TRUST_CENTER_SECTIONS.RESOURCES), label: DOCUMENTS.VIEW_ALL }}
      />
      <div className="overflow-hidden rounded border border-trust-center-border">
        {documents.slice(0, MAX_DOCUMENTS_TO_SHOW).map((document) => (
          <DocumentRow key={document.resource.id} document={document} privateNames={privateNames} />
        ))}
      </div>
    </section>
  )
}
